import React from 'react';
import ReactECharts from 'echarts-for-react';

const CCEFullChart = ({ design1CO2eq, design2CO2eq, design1CO2eq_median, design2CO2eq_median, design1title, design2title }) => {
  if (!design1CO2eq.length || !design2CO2eq.length) {
    return <div>Loading...</div>; // Or any other loading indicator
  }

 // const median = (arr) => {
  //  const sortedArr = arr.slice().sort((a, b) => a - b);
  //  const mid = Math.floor(sortedArr.length / 2);
  //  return sortedArr.length % 2 !== 0 ? sortedArr[mid] : (sortedArr[mid - 1] + sortedArr[mid]) / 2;
  //};

  const percentile = (arr, p) => {
    const sortedArr = arr.slice().sort((a, b) => a - b);
    const idx = Math.ceil((p / 100) * sortedArr.length) - 1;
    return sortedArr[idx];
  };

  const CO2eqCumsum1 = design1CO2eq.map(arr => arr.map(period => period.reduce((acc, val) => acc + val, 0) / 1e6));
    const data1Median = design1CO2eq_median.map(row => row.reduce((acc, val) => acc + val, 0) / 1e6);
  //const data1Median = CO2eqCumsum1[0].map((_, idx) => median(CO2eqCumsum1.map(row => row[idx])));
    const data2Median = design2CO2eq_median.map(row => row.reduce((acc, val) => acc + val, 0) / 1e6);
  const data1Up = CO2eqCumsum1[0].map((_, idx) => percentile(CO2eqCumsum1.map(row => row[idx]), 97.5));
  const data1Low = CO2eqCumsum1[0].map((_, idx) => percentile(CO2eqCumsum1.map(row => row[idx]), 2.5));

  const CO2eqCumsum2 = design2CO2eq.map(arr => arr.map(period => period.reduce((acc, val) => acc + val, 0) / 1e6));
 // const data2Median = CO2eqCumsum2[0].map((_, idx) => median(CO2eqCumsum2.map(row => row[idx])));

  const data2Up = CO2eqCumsum2[0].map((_, idx) => percentile(CO2eqCumsum2.map(row => row[idx]), 97.5));
  const data2Low = CO2eqCumsum2[0].map((_, idx) => percentile(CO2eqCumsum2.map(row => row[idx]), 2.5));

  const analysisPeriod = design1CO2eq[0].length;
  const X = Array.from({ length: analysisPeriod }, (_, i) => i + 1);

  const option = {
    title: {
      text: 'Cumulative GHG Emission vs. Analysis Period',
      left: 'center',
    },
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'cross',
      },
      formatter: function (params) {
        const year = params[0].axisValue;
        const design1MedianSeries = params.find(p => p.seriesName === `${design1title} Median`);
        const design2MedianSeries = params.find(p => p.seriesName === `${design2title} Median`);

        const design1Median = design1MedianSeries ? Math.round(design1MedianSeries.data * 100) / 100 : 'N/A';
        const design2Median = design2MedianSeries ? Math.round(design2MedianSeries.data * 100) / 100 : 'N/A';

        return `Year: ${year}<br/>${design1title} Median: ${design1Median} kt<br/>${design2title} Median: ${design2Median} kt`;
      }
    },
    xAxis: {
      type: 'category',
      data: X,
      name: 'Analysis Period (Years)',
      nameLocation: 'middle',
      nameGap: 30,
          // Custom ticks to display
          axisTick: {
              show: false,
              interval: 5, // Ensure all ticks are shown
          },
          min: 0, // Set minimum value for x-axis
          max: 50, // Set maximum value for x-axis
          // Set the tick values explicitly
          axisLabel: {
              formatter: function (value) {
                  // Create custom ticks: 1, 5, 10, 15, ..., 50
                  const customTicks = [0, 5, 10, 15, 20, 25, 30, 35, 40, 45, 50];
                  return customTicks.includes(parseInt(value)) ? value : '';
              },
              interval: 0 // This will ensure every label is checked for formatting
          },
      },
    yAxis: {
        type: 'value',
        axisLine: {
            show: true, // Show the axis line with default color
        },
        axisTick: {
            show: true, // Show tick marks with default style
        },
      name: 'Cumulative GHG emission (CO2-eq kt)',
      nameLocation: 'middle',
      nameGap: 50,
    },
    series: [
      {
        name: design1title + ' 95% CI',
        type: 'line',
        data: data1Low,
        lineStyle: {
          opacity: 0,
        },
        stack: 'confidence-band',
        areaStyle: {
          color: '#ccc',
          opacity: 0,
        },
        symbol: 'none',
        itemStyle: {
          color: '#ccc',  // Ensure this matches the area color
        },
      },
      {
        name: design1title + ' 95% CI Upper',
        type: 'line',
        data: data1Up.map((up, idx) => up - data1Low[idx]), // difference between upper and lower
        lineStyle: {
          opacity: 0,
        },
        areaStyle: {
          color: '#bcd4e3',
        },
        stack: 'confidence-band',
        symbol: 'none',
        itemStyle: {
          color: '#bcd4e3',  // Ensure this matches the area color
        },
      },
      {
        name: design1title + ' Median',
        type: 'line',
        data: data1Median,
        lineStyle: {
          color: '#0092C2',
          width: 2,
        },
        itemStyle: {
          color: '#0092C2',  // Ensure this matches the line color
        },
        showSymbol: false,
      },
      {
        name: design2title + ' 95% CI',
        type: 'line',
        data: data2Low,
        lineStyle: {
          opacity: 0,
        },
        stack: 'confidence-band-hma',
        areaStyle: {
          color: '#ddd',
          opacity: 0,
        },
        symbol: 'none',
        itemStyle: {
          color: '#ddd',  // Ensure this matches the area color
        },
      },
      {
        name: design2title + ' 95% CI Upper',
        type: 'line',
        data: data2Up.map((up, idx) => up - data2Low[idx]), // difference between upper and lower
        lineStyle: {
          opacity: 0,
        },
        areaStyle: {
          color: '#F7DCD1',
        },
        stack: 'confidence-band-hma',
        symbol: 'none',
        itemStyle: {
          color: '#F7DCD1',  // Ensure this matches the area color
        },
      },
      {
        name: design2title + ' Median',
        type: 'line',
        data: data2Median,
        lineStyle: {
          color: '#D95319',
          width: 2,
        },
        itemStyle: {
          color: '#D95319',  // Ensure this matches the line color
        },
        showSymbol: false,
      },
    ],
    legend: {
      data: [
            { name: design1title + ' Median', icon: 'rect', itemStyle: { color: '#0092C2'}},
            { name: design1title + ' 95% CI', icon: 'rect', itemStyle: { color: '#bcd4e3' }},
            { name: design2title + ' Median', icon: 'rect', itemStyle: { color: '#D95319' } },
            { name: design2title + ' 95% CI', icon: 'rect', itemStyle: { color: '#F7DCD1' }},
      ],
        top: '5%',
        itemHeight: 10,
    },
    grid: {
      left: '10%',
      right: '10%',
      bottom: '15%',
      containLabel: true,
    },
  };

  return <ReactECharts option={option} style={{ height: '500px', width: '100%' }} />;
};

export default CCEFullChart;
